import { native } from '@forest/native-services'
import { $userInfo } from '~/store'

export function openIntercom({
  node,
  orderId,
  transactionId,
  additional,
}: {
  node: string
  orderId?: string
  transactionId?: string | null
  additional?: Record<string, string>
}) {
  const userInfo = $userInfo.get()
  const url = new URL('forestapp://instant/intercom')
  url.search = new URLSearchParams({
    space: '0',
    order_id: orderId ?? '',
    transaction_id: transactionId ?? '',
    occurs_at: node,
    server_region: userInfo?.server ?? '',
    user_id: userInfo?.user_id.toString() ?? '',
    ...additional,
  }).toString()
  native.general.openURL(url.toString())
}
